import React, { useState, useEffect, useRef } from "react";
import Video1 from "../../assets/Video/Reel_3_how_to.mp4";
import Video2 from "../../assets/Video/Reel_2_how_to.mp4";
import Shop_Ship from "../../assets/images/Shop-Ship.jpeg";
import Sign_up from "../../assets/images/Sign-up.jpeg";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import CustomTitle from "../sharedComponents/customTitle";
const CountOrdersSection = () => {
  const { t, i18n } = useTranslation();
  const direction = useLanguageDirection();
  const video1Ref = useRef(null);
  const video2Ref = useRef(null);
  const [isPaused1, setIsPaused1] = useState(true);
  const [isPaused2, setIsPaused2] = useState(true);

  const togglePlay1 = () => {
    const video = video1Ref.current;
    if (!video) return;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  };
  const togglePlay2 = () => {
    const video = video2Ref.current;
    if (!video) return;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  };
  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    i18n.changeLanguage(savedLanguage);
  }, [i18n]);

  return (
    <div className="" dir={direction}>
      <div className="px-4 lg:px-0 max-container">
        <CustomTitle title={t("countOrdersSection.title")} />
        <div className="relative my-8 group">
          <video
            ref={video1Ref}
            className="w-full lg:h-[600px]  min-h-[635.91px] lg:bg-transparent bg-black max-w-fit mx-auto"
            controls
            onPlay={() => setIsPaused1(false)}
            onPause={() => setIsPaused1(true)}
            onEnded={() => setIsPaused1(true)}
            poster={Shop_Ship}
          >
            <source src={Video1} type="video/mp4" />
          </video>

          {isPaused1 && (
            <div
              className="absolute inset-0 z-10 flex items-center justify-center cursor-pointer max-w-[400px] mx-auto  "
              onClick={togglePlay1}
            >
              <div className="p-3 mb-5 bg-white rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="rgb(251 216 7)"
                  viewBox="0 0 16 16"
                  className="opacity-90"
                >
                  <path d="M6.271 3.055A.5.5 0 0 0 5.5 3.5v9a.5.5 0 0 0 .77.424l7-4.5a.5.5 0 0 0 0-.848l-7-4.5z" />
                </svg>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="px-4 lg:px-0 max-container">
        <CustomTitle title={t("howSignup")} />
        <div className="relative my-8 group">
          <video
            ref={video2Ref}
            className="w-full lg:h-[600px]  min-h-[635.91px] lg:bg-transparent bg-black max-w-fit mx-auto "
            controls
            onPlay={() => setIsPaused2(false)}
            onPause={() => setIsPaused2(true)}
            onEnded={() => setIsPaused2(true)}
            poster={Sign_up}
          >
            <source src={Video2} type="video/mp4" />
          </video>

          {isPaused2 && (
            <div
              className="absolute inset-0 z-10 flex items-center justify-center cursor-pointer max-w-[400px] mx-auto"
              onClick={togglePlay2}
            >
              <div className="p-3 mb-5 bg-white rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="rgb(251 216 7)"
                  viewBox="0 0 16 16"
                  className="opacity-90"
                >
                  <path d="M6.271 3.055A.5.5 0 0 0 5.5 3.5v9a.5.5 0 0 0 .77.424l7-4.5a.5.5 0 0 0 0-.848l-7-4.5z" />
                </svg>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default CountOrdersSection;
